import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from '@chakra-ui/react';
import { forwardRef } from 'react';

export { LinkBox, LinkOverlay } from '@chakra-ui/react';

type LinkVariant = 'primary' | 'neutral' | 'subtle';

export type LinkProps = Omit<ChakraLinkProps, 'variant'> & {
  variant?: LinkVariant;
  isExternal?: boolean;
};

const variantProps: Record<LinkVariant, Partial<ChakraLinkProps>> = {
  primary: {
    color: 'green.700',
    fontWeight: 'medium',
    _hover: { color: 'green.800' },
  },
  neutral: {
    color: 'gray.700',
    fontWeight: 'inherit',
    _hover: { color: 'gray.800' },
  },
  subtle: {
    color: 'inherit',
    fontWeight: 'inherit',
    textDecoration: 'underline',
  },
};

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ isExternal = false, variant = 'primary', ...rest }, ref) => (
    <ChakraLink
      ref={ref}
      focusRing="none"
      tabIndex={0} // Make all links tabbable
      _focus={{ textDecoration: 'underline' }} // Instead of the default focus ring, underline focused links
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...variantProps[variant]}
      {...rest}
    />
  )
);

export default Link;
